export default __webpack_public_path__ + "static/media/dark-compliance.2aadd353.png";